<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="名稱">
        <el-input v-model="form.Name"></el-input>
      </el-form-item>
      <el-form-item label="權重">
        <el-input v-model="form.Weigh" type="number"></el-input>
      </el-form-item>
      <el-form-item label="置頂">
        <el-switch
          v-model="form.IsTop"
          class="switch-deploy"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item>
      <el-form-item label="狀態">
        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        Name: '',
        Weigh: 0,
        IsActive: true,
        IsTop: false
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.Name : '新增標籤'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Weigh = parseInt(this.form.Weigh)
      let promise = this.isEdit
        ? this.$services.postTag.edit(this, this.form)
        : this.$services.postTag.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      })
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.post.tagList.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.post.tagList.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.post.tagList, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown postTag for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Name) {
        errMsg = '請輸入標籤'
      }
      if (errMsg != null) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            Weigh: 0,
            IsActive: true
          }
        }
      }
    }
  }
}
</script>
